import React, { useState } from "react";
import { withRouter } from "react-router-dom";
import eomMarService from "../services/eom-mar-service";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import Loader from "react-loader-spinner";
import cogoToast from "cogo-toast";
import "react-datepicker/dist/react-datepicker.css";

const MARDrugModal = ({ selectedRow, onCloseModal }) => {
  const [loading, setLoading] = useState(false);
  const [ndc, setNDC] = useState(selectedRow?.ndc || "");
  const [cost, setCost] = useState(selectedRow?.cost || "");
  const [description, setDescription] = useState(
    selectedRow?.description || ""
  );
  const [drug, setDrug] = useState(selectedRow?.drug_name || "");
  const [error, setError] = useState(false);

  const onSubmit = async () => {
    try {
      if (!ndc.length || !description?.length || !drug?.length || !cost) {
        setError(true);
        return;
      }
      var data = {
        ndc: ndc,
        description: description,
        drug_name: drug,
        cost: cost,
      };
      setLoading(true);
      if (selectedRow?.id) {
        data["id"] = selectedRow?.id;
        await eomMarService.updateMARDrug(data);
      } else {
        await eomMarService.createMARDrug(data);
      }
      setLoading(false);
      onCloseModal(true);
    } catch (e) {
      setLoading(false);
      const { hide } = cogoToast.error(
        "Error submitting data. Please try after sometime.",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
    }
  };
  return (
    <>
      <div
        className={`inline-block customtop absolute z-50 ${
          loading ? "show" : "hidden"
        }`}
      >
        <Loader
          type="Oval"
          color="#00BFFF"
          height={50}
          width={50}
          timeout={300000} //3 secs
        />
      </div>
      <div className="text-xl">{selectedRow?.id ? "Edit" : "Create"} </div>
      <div className="bg-white w-full mx-auto mt-6 mb-4 rounded ">
        <div className="p-2 text-xs">
          <ul>
            <li className="inline-block text-xs leading-6 text-menu_txt w-full mb-3">
              <label className="text-labelclr font-semibold text-sm tracking-wider">
                Drug Description
              </label>
              <span className="text-xs md:text-sm text-hlred ml-1">*</span>
              <input
                id="description"
                name="description"
                type="text"
                placeholder="Drug Description"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                className={` ${
                  error && description.length === 0 ? "border-red-400" : ""
                } border focus:outline-none h-11 rounded-md pl-2 font-normal w-full text-fogotpwsd_login text-sm`}
              />
              {error && description.length === 0 && (
                <p className="text-xs md:text-sm md:pt-1 text-hlred">
                  You must specify description
                </p>
              )}
            </li>
            <li className="inline-block text-xs leading-6 text-menu_txt w-full mb-3">
              <label className="text-labelclr font-semibold text-sm tracking-wider">
                NDC
              </label>
              <span className="text-xs md:text-sm text-hlred ml-1">*</span>
              <input
                id="ndc"
                name="ndc"
                type="text"
                placeholder="NDC"
                value={ndc}
                onChange={(e) => setNDC(e.target.value)}
                className={` ${
                  error && ndc.length === 0 ? "border-red-400" : ""
                } border focus:outline-none h-11 rounded-md pl-2 font-normal w-full text-fogotpwsd_login text-sm`}
              />

              {error && ndc.length === 0 && (
                <p className="text-xs md:text-sm md:pt-1 text-hlred">
                  You must specify NDC
                </p>
              )}
            </li>

            <li className="inline-block text-xs leading-6 text-menu_txt w-full mb-3">
              <label className="text-labelclr font-semibold text-sm tracking-wider">
                Drug name
              </label>
              <span className="text-xs md:text-sm text-hlred ml-1">*</span>

              <input
                id="drug_name"
                name="drug_name"
                type="text"
                placeholder="Drug name"
                value={drug}
                onChange={(e) => setDrug(e.target.value)}
                className={` ${
                  error && drug.length === 0 ? "border-red-400" : ""
                } border focus:outline-none h-11 rounded-md pl-2 font-normal w-full text-fogotpwsd_login text-sm`}
              />
              {error && drug.length === 0 && (
                <p className="text-xs md:text-sm md:pt-1 text-hlred">
                  You must specify drug name
                </p>
              )}
            </li>

            <li className="inline-block text-xs leading-6 text-menu_txt w-full mb-3">
              <label className="text-labelclr font-semibold text-sm tracking-wider">
                Cost
              </label>
              <span className="text-xs md:text-sm text-hlred ml-1">*</span>
              <input
                id="cost"
                name="cost"
                type="number"
                placeholder="Cost"
                value={cost}
                onChange={(e) => setCost(e.target.value)}
                className={` ${
                  error && cost.length === 0 ? "border-red-400" : ""
                } border focus:outline-none h-11 rounded-md pl-2 font-normal w-full text-fogotpwsd_login text-sm`}
              />

              {error && cost.length === 0 && (
                <p className="text-xs md:text-sm md:pt-1 text-hlred">
                  You must specify cost
                </p>
              )}
            </li>

            <li className="text-center">
              <button
                disabled={loading}
                onClick={() => onSubmit()}
                className={
                  loading
                    ? "opacity-50 cursor-not-allowed text-white w-full sm:w-auto h-8 px-6 mt-2 sm:mt-5 bg-header_bg rounded text-xs font-medium capitalize focus:outline-none"
                    : "text-white w-full sm:w-auto h-8 px-6 mt-2 sm:mt-5 bg-header_bg rounded text-xs font-medium capitalize focus:outline-none"
                }
              >
                SUBMIT
              </button>
            </li>
          </ul>
        </div>
      </div>
    </>
  );
};

export default withRouter(
  connect(
    () => ({}),
    (dispatch) => {
      return bindActionCreators({}, dispatch);
    }
  )(MARDrugModal)
);
